import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

function RedefinirSenha() {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isAutenticacao, setIsAutenticacao] = useState(false);
  const [redirectAfter, setRedirectAfter] = useState('/disciplinas');

  useEffect(() => {



    const params = new URLSearchParams(location.search);
    const tokenValue = params.get('token');
    const tipo = params.get('tipo');
    const redirect = params.get('redirect');





    if (tokenValue) {
        setToken(tokenValue);
    } else {
        setMessage('Token inválido. Contate o suporte.');
    }

    if (tipo === 'autenticacao') {
        setIsAutenticacao(true);
    }

    if (redirect) {
        setRedirectAfter(redirect);
    }




}, [location]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!token || !newPassword || !confirmPassword) {
      setMessage('Preencha todos os campos.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('As senhas não coincidem.');
      return;
    }

    if (newPassword.length < 2) {
      setMessage('A senha deve ter pelo menos 2 caracteres.');
      return;
    }



    // atualiza a senha
    try {
      const response = await fetch(
          `https://rvensino.com.br/get.php?action=updateSenhaToken&token=${token}&senha=${newPassword}`
      );

      const textResponse = await response.text();



      let data;
      try {
        data = JSON.parse(textResponse);
      } catch (error) {
        console.error('Erro ao analisar JSON:', error);
        setMessage('Erro inesperado. Tente novamente.');
        return;
      }

      if (data.sucess) {
      
        setMessage(data.sucess + '');
        const prefillEmail = localStorage.getItem('prefillEmail') || '';
      
      
        localStorage.removeItem('prefillEmail');
        sessionStorage.setItem('prefillPassword', newPassword);
      
      
        if (prefillEmail) sessionStorage.setItem('prefillEmail', prefillEmail);
        
        setTimeout(() => navigate(`/login?redirect=${encodeURIComponent(redirectAfter)}`), 3000);
      
      
      } else {
        setMessage(data.error || 'Erro ao redefinir a senha.');
      }




    } catch (error) {
      console.error('Erro ao redefinir senha:', error);
      setMessage('Um erro ocorreu. Tente novamente mais tarde.');
    }
  };






  return (
    <div className="page-container login">
      <div className="login-container">
        <form onSubmit={handlePasswordReset} className="form-redefine-password">
          <div className="arrow-back cadastro">
            <Link to="/login" className="no-link-style">
              <ArrowBackOutlinedIcon style={{ color: '#000', fontSize: 35 }} className="sidebar-icon custom-arrow-icon" />
            </Link>
          </div>
          
          
          <Link to="/login" className="no-link-style">
            <img src="https://rveducacao.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className="login-logo" />
          </Link>



          <input
              type="password"
              placeholder={isAutenticacao ? "Digite sua senha" : "Senha"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
          />
          <input
              type="password"
              placeholder={isAutenticacao ? "Confirme sua senha" : "Confirmar senha"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
          />
          <button className="button" type="submit">
              {isAutenticacao ? "Redefinir Senha" : "Autenticar"}
          </button>


          {message && <p className="message">{message}</p>}
        </form>
      </div>
    </div>
  );
}

export default RedefinirSenha;
